import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSmsBroadcasts as GetSmsBroadcastsQuery,
    GetSmsBroadcasts_smsBroadcasts as SmsBroadcast,
    GetSmsBroadcastsVariables as GetSmsBroadcastsQueryVariables,
} from 'nutshell-graphql-types';

import GET_SMS_BROADCASTS from '../queries/get-sms-broadcasts.graphql';

export const useGetSmsBroadcasts = (
    variables: GetSmsBroadcastsQueryVariables
): {
    smsBroadcasts: SmsBroadcast[] | null;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const {data, error, loading} = useQuery<GetSmsBroadcastsQuery, GetSmsBroadcastsQueryVariables>(
        GET_SMS_BROADCASTS,
        {
            variables: variables,
            fetchPolicy: 'cache-and-network',
        }
    );

    const smsBroadcastsData = data ? data.smsBroadcasts : null;
    const smsBroadcasts = smsBroadcastsData;

    return {
        smsBroadcasts: smsBroadcasts,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
    };
};
